import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const PRICE_COPY = {
  en: {
    kicker: 'Premium access',
    subtitle: 'Choose a plan that fits your pace. Tokens are added instantly after payment confirmation.',
    choose: 'Choose',
    included: 'Included with your first registration',
    freeBadge: 'Starter',
    featuredBadge: 'Popular',
  },
  ru: {
    kicker: 'Премиальный доступ',
    subtitle: 'Выберите пакет под ваш темп. Токены зачисляются сразу после подтверждения оплаты.',
    choose: 'Выбрать',
    included: 'Входит в первую регистрацию',
    freeBadge: 'Старт',
    featuredBadge: 'Популярный',
  },
};

const PRICE_PLANS = {
  ru: [
    {
      id: 'free',
      name: 'Бесплатно',
      currentPrice: null,
      oldPrice: null,
      tokens: '35 000 токенов',
      bonus: null,
      details: [
        'Предоставляется при первой регистрации',
        'Доступен полный функционал',
        'Хватит на 1 диалог',
      ],
      featured: false,
      free: true,
    },
    {
      id: 'p100',
      name: 'Мини',
      currentPrice: '100₽',
      oldPrice: '200₽',
      tokens: '33 000 токенов',
      bonus: null,
      details: [
        'Доступен полный функционал',
        'Хватит примерно на 1 консультацию / диалог',
      ],
      opt: '5',
      sum: 100,
      curr: 'RUB',
      featured: false,
    },
    {
      id: 'p300',
      name: 'Базовый',
      currentPrice: '300₽',
      oldPrice: '500₽',
      tokens: '100 000 токенов',
      bonus: null,
      details: [
        'Доступен полный функционал',
        'Хватит на 2-3 консультации / диалога',
      ],
      opt: '2',
      sum: 300,
      curr: 'RUB',
      featured: false,
    },
    {
      id: 'p500',
      name: 'Комфорт',
      currentPrice: '500₽',
      oldPrice: '800₽',
      tokens: '165 000 токенов',
      bonus: null,
      details: [
        'Доступен полный функционал',
        'Хватит на 4-6 консультаций / диалогов',
      ],
      opt: '6',
      sum: 500,
      curr: 'RUB',
      featured: true,
    },
    {
      id: 'p800',
      name: 'Активный',
      currentPrice: '800₽',
      oldPrice: '1 100₽',
      tokens: '264 000 токенов',
      bonus: null,
      details: [
        'Доступен полный функционал',
        'Хватит на 7-9 консультаций / диалогов',
      ],
      opt: '7',
      sum: 800,
      curr: 'RUB',
      featured: false,
    },
    {
      id: 'p1000',
      name: 'Интенсив',
      currentPrice: '1 000₽',
      oldPrice: '1 500₽',
      tokens: '330 000 токенов',
      bonus: '+ 20 000 токенов в подарок',
      details: [
        'Доступен полный функционал',
        'Хватит на 10-14 консультаций / диалогов',
      ],
      opt: '3',
      sum: 1000,
      curr: 'RUB',
      featured: false,
    },
    {
      id: 'p1500',
      name: 'Премиум',
      currentPrice: '1 500₽',
      oldPrice: '2 250₽',
      tokens: '450 000 токенов',
      bonus: '+ 75 000 токенов в подарок',
      details: [
        'Доступен полный функционал',
        'Хватит на 15-20 консультаций / диалогов',
      ],
      opt: '8',
      sum: 1500,
      curr: 'RUB',
      featured: false,
    },
    {
      id: 'p2700',
      name: 'Максимум',
      currentPrice: '2 700₽',
      oldPrice: '4 500₽',
      tokens: '900 000 токенов',
      bonus: '+ 100 000 токенов в подарок',
      details: [
        'Доступен полный функционал',
        'Хватит на 21-30 консультаций / диалогов',
      ],
      opt: '4',
      sum: 2700,
      curr: 'RUB',
      featured: false,
    },
  ],
  en: [
    {
      id: 'free',
      name: 'Free',
      currentPrice: null,
      oldPrice: null,
      tokens: '35,000 tokens',
      bonus: null,
      details: [
        'Provided upon first registration',
        'Full functionality available',
        'Enough for 1 dialogue',
      ],
      featured: false,
      free: true,
    },
    {
      id: 'p300',
      name: 'Basic',
      currentPrice: '300₽',
      oldPrice: '500₽',
      tokens: '100,000 tokens',
      bonus: null,
      details: [
        'Full functionality available',
        'Enough for 3-4 dialogues',
      ],
      opt: '2',
      sum: 300,
      curr: 'RUB',
      featured: true,
    },
    {
      id: 'p1000',
      name: 'Premium',
      currentPrice: '1,000₽',
      oldPrice: '1,500₽',
      tokens: '350,000 tokens',
      bonus: null,
      details: [
        'Full functionality available',
        'Enough for 6-8 dialogues',
      ],
      opt: '3',
      sum: 1000,
      curr: 'RUB',
      featured: false,
    },
    {
      id: 'p2700',
      name: 'Unlimited flow',
      currentPrice: '2,700₽',
      oldPrice: '4,500₽',
      tokens: '1,000,000 tokens',
      bonus: null,
      details: [
        'Full functionality available',
        'Enough for 30-40 dialogues',
      ],
      opt: '4',
      sum: 2700,
      curr: 'RUB',
      featured: false,
    },
  ],
};

function isPlanVisible(planId, srcpValue) {
  if (planId === 'free') {
    return true;
  }

  if (planId === 'p100' && srcpValue !== 'yah1') {
    return false;
  }

  const hiddenPlans = {
    yah: ['p100', 'p300', 'p500', 'p800'],
    yah5: ['p100', 'p300'],
    yah8: ['p100', 'p300', 'p500'],
    yah15: ['p100', 'p300', 'p500', 'p800', 'p1000'],
  };

  return !(hiddenPlans[srcpValue] || []).includes(planId);
}

class PriceComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      srcpValue: '',
      promocode: '',
      promocodeMessageKey: '', // New state to hold the message key for localization
      isError: false, // New state to determine if the message is an error
    };
  }

  getBrowserLanguage() {
    const language = this.props.intl.locale.split(/[-_]/)[0];
    return language ? language : 'en';
  }

  componentDidMount() {
    this.props.eventToGAnalitycs("price_show");
    this.checkSrcpValue();
  }

  checkSrcpValue = () => {
    const srcpValue = localStorage.getItem('srcp');
    this.setState({ srcpValue });
  }

  handleFieldEdit(name, e) {
    this.setState({[name]: e.target.value || ''});
  }

  getCopy() {
    return PRICE_COPY[this.getBrowserLanguage()] || PRICE_COPY.en;
  }

  getPlans() {
    return (PRICE_PLANS[this.getBrowserLanguage()] || PRICE_PLANS.en)
      .filter((plan) => isPlanVisible(plan.id, this.state.srcpValue));
  }

  handlePlanSelect = (plan) => {
    if (!plan.opt || !this.props.onSelectPlan) {
      return;
    }

    this.props.eventToGAnalitycs('price_plan_select', {
      option: plan.opt,
      sum: plan.sum,
      curr: plan.curr,
    });
    this.props.onSelectPlan(plan.opt, plan.sum, plan.curr);
  };

  handleSendPromocode = async () => {
    const { promocode } = this.state;
    
    this.props.eventToGAnalitycs('use_promocode');
    const topic = this.props.tinode.getMeTopic();  
    const query = topic.startMetaQuery().withDesc().build();

    query.desc.inchatgpt = promocode;
    query.desc.inchatgpttype = "use_promocode";
    
    try {
      const result = await topic.getMeta(query);

      if (result.desc.outchatgpt === 'error') {
        // Error case: Invalid or previously used promocode
        this.setState({
          promocodeMessageKey: 'promocode_error',
          isError: true,
        });
      } else {
        // Success case: Promocode applied successfully
        this.setState({
          promocodeMessageKey: 'promocode_success',
          isError: false,
        });
      }

    } catch (error) {
      console.error('Error applying promocode:', error);
      // You can add further error handling here if necessary
    }
  };

  renderPromocodeMessage() {
    const { promocodeMessageKey, isError } = this.state;

    // Conditionally render the message based on the key
    if (!promocodeMessageKey) return null;

    if (this.state.isError) {
      return (
        <div className='error-message' >
          <FormattedMessage id='promocode_error' />
        </div>
      );
    } else {
      return (
        <div className='success-message'>
          <FormattedMessage id='promocode_success' />
        </div>
      );
    }
  }

  renderPlan(plan) {
    const copy = this.getCopy();
    const classes = [
      'price-card',
      plan.free ? 'price-card--free' : '',
      plan.featured ? 'price-card--featured' : '',
    ].filter(Boolean).join(' ');

    return (
      <article className={classes} key={plan.id}>
        <div className="price-card-top">
          <div>
            <div className="price-card-name">{plan.name}</div>
            {plan.oldPrice ? <div className="price-card-old">{plan.oldPrice}</div> : null}
            <div className="price-card-price">{plan.currentPrice || plan.name}</div>
          </div>
          <div className="price-card-badge">
            {plan.free ? copy.freeBadge : plan.featured ? copy.featuredBadge : null}
          </div>
        </div>

        <div className="price-card-tokens">{plan.tokens}</div>
        {plan.bonus ? <div className="price-card-bonus">{plan.bonus}</div> : null}

        <ul className="price-card-points">
          {plan.details.map((detail) => (
            <li key={detail}>{detail}</li>
          ))}
        </ul>

        {plan.free ? (
          <div className="price-card-included">{copy.included}</div>
        ) : (
          <button className="primary" type="button" onClick={() => this.handlePlanSelect(plan)}>
            {copy.choose}
          </button>
        )}
      </article>
    );
  }

  render() {
    const copy = this.getCopy();
    const plans = this.getPlans();

    return (
      <>
        <div className='price-overlay'>
          <div className='price-container'>
            <div className="cancel">
              <a href="#" onClick={e => { e.preventDefault(); this.props.onCancel(); }}>
                <i className="material-icons gray">close</i>
              </a>
            </div>
            <div className="token-modal-header">
              <div className="token-modal-kicker">{copy.kicker}</div>
              <h2>
                <FormattedMessage id="choosetarif" defaultMessage="Choose payment option" description="Choose payment option" />
              </h2>
              <p>{copy.subtitle}</p>
            </div>

            <div className="price-grid">
              {plans.map((plan) => this.renderPlan(plan))}
            </div>

            <div className="promocode-panel">
                <label className="small" htmlFor="promocode">
                  <FormattedMessage id="input_promocode" defaultMessage="If you have a promo code, enter it" />
                </label>
                <div className="promocode-block">
                  <div className='promocode-text'>
                    <FormattedMessage id="promocode" defaultMessage="promocode">
                      {(placeholder) => (
                        <input type="text" id="promocode" placeholder={placeholder}
                          value={this.state.promocode} 
                          onChange={this.handleFieldEdit.bind(this, 'promocode')}
                          required 
                          tabIndex={0} 
                        />
                      )}
                    </FormattedMessage>
                  </div>
                  <button className='secondary' type="button" onClick={this.handleSendPromocode}>
                    <FormattedMessage id="button_promocode" defaultMessage="Apply" />
                  </button>
                </div>

                {/* Display promocode message */}
                {this.renderPromocodeMessage()}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default injectIntl(PriceComponent);
